import { TokenStorage } from '@/config/storage';

/**
 * Limpa tokens inválidos do localStorage
 * Útil para resolver problemas de "Token reutilizado detectado"
 */
export const clearInvalidTokens = () => {
  try {
    console.log('[clearInvalidTokens] Limpando tokens inválidos...');
    
    // Limpa toda a sessão
    TokenStorage.clearSession(false); // false = não notifica outras abas
    
    // Limpa também da memória se existir
    if (typeof window !== 'undefined') {
      delete (window as any).__multimarcas_access_token;
    }
    
    console.log('[clearInvalidTokens] Tokens limpos com sucesso');
    
    // Recarrega a página para garantir estado limpo
    window.location.reload();
  } catch (error) {
    console.error('[clearInvalidTokens] Erro ao limpar tokens:', error);
  }
};

/**
 * Verifica se há tokens inválidos no localStorage
 */
export const hasInvalidTokens = (): boolean => {
  try {
    const token = TokenStorage.getAccessToken();
    const user = TokenStorage.getUser();
    
    // Se há token mas não há usuário, é inválido
    if (token && !user) {
      return true;
    }
    
    // Se há token mas está malformado, é inválido
    if (token && !token.includes('.')) {
      return true;
    }
    
    return false;
  } catch {
    return true;
  }
};

/**
 * Função para ser chamada no console do navegador para debug
 */
export const debugTokens = () => {
  try {
    const token = TokenStorage.getAccessToken();
    const user = TokenStorage.getUser();
    const refreshToken = TokenStorage.getRefreshToken();
    
    console.log('=== Debug Tokens ===');
    console.log('Access Token:', token ? `${token.substring(0, 20)}...` : 'null');
    console.log('Refresh Token:', refreshToken ? `${refreshToken.substring(0, 20)}...` : 'null');
    console.log('User:', user);
    console.log('Has Invalid Tokens:', hasInvalidTokens());
    console.log('===================');
  } catch (error) {
    console.error('Erro no debug:', error);
  }
};

// Expõe as funções globalmente para uso no console do navegador
if (typeof window !== 'undefined') {
  (window as any).clearInvalidTokens = clearInvalidTokens;
  (window as any).debugTokens = debugTokens;
} 